export default __webpack_public_path__ + "static/boys-058ae6ebf79c4e52a03334d063a04233.jpg";